
document.querySelectorAll('.mega-menu').forEach(menu => {
  menu.addEventListener('mouseenter', () => {
    menu.setAttribute('open', 'open');
  });

  menu.addEventListener('mouseleave', () => {
    menu.removeAttribute('open');
  });
});

    // Accordion Toggle
    $('.accordion-toggle').on('click', function () {
      const $toggle = $(this);
      const $content = $toggle.next('.accordion-content');
      const $item = $toggle.closest('.accordion-item');

      $item.toggleClass('active');
      $content.stop(true, true).slideToggle(300);
    });

    // Owl Carousel Initialization
    $('.glry-slidr').owlCarousel({
      loop: true,
      margin: 30,
      dots: false,
      nav: true,
      items: 5,
      autoplay: false,
      responsive: {
        0:     { items: 1 },
        480:   { items: 2 },
        768:   { items: 3 },
        1024:  { items: 4 },
        1200:  { items: 5 }
      }
    });

